module.exports = __webpack_public_path__ + "img/homepage_03.cbe2d6fe.jpg";